import request from "@/request";
import {
  GuideMenuConfigType,
  QuestionType,
  ReplyActionEnum,
} from "@/app/types/typeConfig/chatQuestion";
import { RobotChatPropsType } from "@/app/types/typeConfig/report";

const prefix = "/gw/robot";

export interface QueryWelcomeConfigProps {
  languageCode: string;
  type: number;
  [key: string]: unknown; // 添加索引签名以兼容request参数类型要求
}
export const queryWelcomeConfig = async (params: QueryWelcomeConfigProps) => {
  try {
    const res: string = await request.get(`${prefix}/guide/show`, { params });
    return Promise.resolve(res);
  } catch (err) {
    return Promise.reject(err);
  }
};

export interface QueryGuideMenuProps {
  languageCode: string;
  [key: string]: unknown; // 添加索引签名以兼容request参数类型要求
}
export const queryGuideMenuConfig = async (params: QueryGuideMenuProps) => {
  try {
    const res: GuideMenuConfigType = await request.get(
      `${prefix}/guide/menu/show`,
      { params },
    );
    return Promise.resolve(res);
  } catch (err) {
    return Promise.reject(err);
  }
};

export interface RobotChatResponseType {
  questions: QuestionType[];
  templateFlag: number;
  reply: string;
  action: ReplyActionEnum;
  error?: boolean;
}
export const robotChat = async (params: RobotChatPropsType) => {
  try {
    const data: RobotChatResponseType = await request.post(
      `${prefix}/front/chat`,
      { ...params },
    );
    return Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
